import React from 'react';

import { createRoot } from 'react-dom/client';
import App from './App';
import { initErrorReporting } from './config/errorReporting';
import { restoreOtaReturnPath } from './utils/otaUtils';
import './styles/root.scss';
import './styles/flags.scss';

import 'primeicons/primeicons.css';

initErrorReporting();

// Before the router reads the URL: after an optional OTA update, go back to the page the user was on.
restoreOtaReturnPath();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
